import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import _ from 'lodash'
import {contact} from 'services/registration.service'

export interface contactUs {
    isLoading: boolean
    error: any
    response: any
}

const initialState: contactUs = {
    isLoading: false,
    error: null,
    response: null
}

const formatPhoneNumber = (phoneCode: string): string => {
    const value = phoneCode.split(':', 1)[0]
    return value
}

const throwError = (data) => {
    if (!data.successFlag || typeof data === 'string') {
        throw Error(`${data?.errorList[0]?.text}`)
    }
}

export const contactUsAction = createAsyncThunk('contact-us', async (payload: any, {rejectWithValue}) => {
    try {
        const formData = new FormData()
        formData.append('branchCountryCode', payload.branchCountryCode)
        formData.append('browserName', payload.browserName)
        formData.append('browserVersion', payload.fullBrowserVersion)
        formData.append('userID', payload.userID)
        formData.append('carrier', payload.carrier === '-Select-' ? 'CPS' : payload.carrier)
        formData.append('description', payload.description)
        formData.append('email', payload.email)
        formData.append('function', payload.issue)
        formData.append('name', payload.name)
        formData.append(
            'phone',
            '+' + formatPhoneNumber(payload.countryCode) + ' ' + String(payload.phone.replace(/\D/g, ''))
        )
        const attachments = _.get(payload, 'attachments', {})
        if (attachments?.size > 0) {
            formData.append('attachments', attachments)
        }
        const {data} = await contact(formData)
        throwError(data)
        return data
    } catch (err) {
        return rejectWithValue(err)
    }
})

const contactSlice = createSlice({
    name: 'contact-us',
    initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder.addCase(contactUsAction.pending, (state, action) => {
            state.isLoading = true
            state.error = null
            state.response = null
        })
        builder.addCase(contactUsAction.fulfilled, (state, action) => {
            state.isLoading = false
            state.error = null
            state.response = action.payload
        })
        builder.addCase(contactUsAction.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.payload
            state.response = null
        })
    }
})

export const contactReducer = contactSlice.reducer
